import MuiDialog, { type DialogProps as MuiDialogProps } from '@mui/material/Dialog'
import MuiDialogTitle from '@mui/material/DialogTitle'
import { type ReactNode } from 'react'
import { DialogTitle } from './DialogTitle'

export interface DialogProps extends Omit<MuiDialogProps, 'title'> {
  title?: ReactNode
  onClose?: () => void
  withTitleBar?: boolean
  closeOnBackdropClick?: boolean
}

export function Dialog({
  open,
  title,
  onClose,
  closeOnBackdropClick = true,
  withTitleBar = false,
  children,
  ...props
}: DialogProps) {
  return (
    <MuiDialog maxWidth="xs" fullWidth open={open} {...props} onClose={closeOnBackdropClick ? onClose : undefined}>
      {withTitleBar
        ? (title && <DialogTitle title={title || ''} onClose={onClose} />)
        : (title && <MuiDialogTitle fontSize="16px">{title}</MuiDialogTitle>)}
      {children}
    </MuiDialog>
  )
}
